import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
  CardTitle,
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

import { sitename } from "../../constants/constants";
import WelcomeComp from "./WelcomeComp";
import Apaexlinecolumn from "./Charts/apaexlinecolumn";
import RadialChart from "./Charts/RadialChart";
import InquiryTable from "./InquiryTable";
import LineApexChart from "./Charts/chartapex";
import LeadBymodel from "./LeadBymodel";
const Dashboard = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getAllRoles())
    // dispatch(getAllPermissions())
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Car Dealer")}
          />
          <Row className="align-items-stretch">
            <Col xl="3" className="mb-3">
              <Card className="h-100">
                <CardBody>
                  <WelcomeComp />
                </CardBody>
              </Card>
            </Col>
            <Col xl="6" className="mb-3">
              <Card className="h-100">
                <CardBody>
                  <CardTitle className="mb-4">Sale Analysis Trend</CardTitle>
                  <hr></hr>
                  <Apaexlinecolumn dataColors='["--bs-primary","--bs-primary", "--bs-success"]' />
                </CardBody>
              </Card>
            </Col>
            <Col xl="3" className="mb-3">
              <Card className="h-100">
                <CardBody>
                  <CardTitle className="mb-4">Safe Deal</CardTitle>
                  <RadialChart dataColors='["--bs-primary","--bs-success", "--bs-danger", "--bs-warning"]' />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="align-items-stretch">
            <Col xl="7" className="mb-3">
              <Card className="h-100">
                <CardBody>
                  <InquiryTable />
                </CardBody>
              </Card>
            </Col>
            <Col xl="5" className="mb-3">
              <Card className="h-100">
                <CardBody>
                  <LineApexChart dataColors='["--bs-primary", "--bs-danger"]' />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl="4" className="mb-3">
              <LeadBymodel />
            </Col>
            <Col xl="6"></Col>
            {/* <Col xl="4"></Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Dashboard);
